import React from "react";
import { Button, Input } from "reactstrap";

import "./styles.css";

const DEFAULT_PAGE_SIZES = [10, 20, 50, 100];

/**
 * Paginação PADRÃO de tabela (PO1-2724), extraída da Auditoria de Faturas:
 * "{total} registro(s) · página X de Y", seletor de tamanho e botões
 * Primeiro / Anterior / Próxima / Último (info outline).
 *
 * Props: page, pageSize, total, onPageChange(page), onPageSizeChange(size),
 *        pageSizes, disabled, itemLabel, showPageSize, className.
 * O componente clampa a página em [1, totalPages] e NÃO reseta a página ao
 * trocar o tamanho (o chamador decide, como na tela de origem).
 * Para listas client-side use `paginate` de utils/tableHelpers.
 */
export default function TablePagination({
  page = 1,
  pageSize = 10,
  total = 0,
  onPageChange,
  onPageSizeChange,
  pageSizes = DEFAULT_PAGE_SIZES,
  disabled = false,
  itemLabel = "registro(s)",
  showPageSize = true,
  className = "",
}) {
  const size = Number(pageSize) || DEFAULT_PAGE_SIZES[0];
  const totalItems = Number(total) || 0;
  const totalPages = Math.max(1, Math.ceil(totalItems / size));
  const current = Math.min(Math.max(1, Number(page) || 1), totalPages);

  const go = (next) => {
    const clamped = Math.min(Math.max(1, next), totalPages);
    if (clamped !== current && onPageChange) onPageChange(clamped);
  };

  return (
    <div className={`hub-pagination ${className}`.trim()}>
      <span>
        {totalItems} {itemLabel} · página {current} de {totalPages}
      </span>
      <div className="d-flex align-items-center" style={{ gap: 8 }}>
        {showPageSize ? (
          <Input
            type="select"
            bsSize="sm"
            style={{ width: 90 }}
            value={size}
            onChange={(e) => (onPageSizeChange ? onPageSizeChange(Number(e.target.value)) : undefined)}
            disabled={disabled}
            aria-label="Itens por página"
          >
            {pageSizes.map((s) => (
              <option key={s} value={s}>
                {s}/pág
              </option>
            ))}
          </Input>
        ) : null}
        <Button size="sm" color="info" outline onClick={() => go(1)} disabled={disabled || current <= 1}>
          Primeiro
        </Button>
        <Button size="sm" color="info" outline onClick={() => go(current - 1)} disabled={disabled || current <= 1}>
          Anterior
        </Button>
        <Button
          size="sm"
          color="info"
          outline
          onClick={() => go(current + 1)}
          disabled={disabled || current >= totalPages}
        >
          Próxima
        </Button>
        <Button
          size="sm"
          color="info"
          outline
          onClick={() => go(totalPages)}
          disabled={disabled || current >= totalPages}
        >
          Último
        </Button>
      </div>
    </div>
  );
}
